import React, { useState, useEffect } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import { AddBox } from "@material-ui/icons";
import { Box, Button } from "@material-ui/core";
import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
import PointsTable from "./PointsTable";
import CmtSearch from "@coremat/CmtSearch";
import NewsRequests from "services/news";
import { useDispatch } from "react-redux";
import AddPointDialog from "./AddPointDialog";
import AddBatchPointDialog from "./AddBatchPointDialog";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  scrollbarRoot: {
    height: 275,
  },
  actionsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 20px",
  },
  buttonsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
}));

const PointsContainer = () => {
  const classes = useStyles();
  const [openAddPoint, setOpenAddPoint] = useState(false);
  const [openAddBatchPoint, setOpenAddBatchPoint] = useState(false);
  const [searchVal, setSearchVal] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    if (searchVal) {
      dispatch(NewsRequests.getAllPoints(1, searchVal));
    } else {
      dispatch(NewsRequests.getAllPoints(1, ""));
    }
  }, [searchVal]);

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <Box className={classes.actionsContainer}>
          <Box className={classes.buttonsContainer}>
            <Box>
              <CmtSearch
                border={false}
                onlyIcon={false}
                iconPosition="left"
                align="left"
                placeholder="جست و جو"
                value={searchVal}
                onChange={(e) => setSearchVal(e.target.value)}
              />
            </Box>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<AddToPhotosIcon />}
              onClick={() => setOpenAddBatchPoint(true)}
              style={{ marginBlock: "10px" }}
            >
              اضافه کردن گروهی
            </Button>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<AddBox />}
              onClick={() => setOpenAddPoint(true)}
              style={{ marginRight: 14, marginBlock: "10px" }}
            >
              اضافه کردن سکه
            </Button>
          </Box>
        </Box>
        <PointsTable searchInput={searchVal} />
      </CmtCardContent>
      <AddPointDialog
        open={openAddPoint}
        handleClose={() => setOpenAddPoint(false)}
      />
      <AddBatchPointDialog
        open={openAddBatchPoint}
        handleClose={() => setOpenAddBatchPoint(false)}
      />
    </CmtCard>
  );
};

export default PointsContainer;
